




export type BaseFunction =(...props:any)=>void



/**
 * 消息头部prop
 */
export interface MessageHeaderProps {
  title?: string;
  des?:string;
  LeftSolt?: React.ReactNode;
}

export type TableRowSelection<T extends object = object> = any['rowSelection'];

export interface MessageMenuType extends BaseLabelType {
  key:string
}

export interface MessageViewCountType {
  sum: number
  unRead: number
}
export interface CommonTableProps {
  tableConfig: tableProps
  pageChange?:(page:number,pageSize:number)=>void
  pagination?:any
  showSelectText?:boolean
  paginationConfig?:PaginationConfigType
  onClick?: (item: any) => void
  [data:string]:any
}
export interface tableProps {
  columns: any[]
  dataSource: any[]
  rowSelection?:any
  pagination?: any
  
  loading?: any
  rowKey?: string
  scroll?: {
    x?: number
    y?: number
  }
  [data:string]:any
}

export interface BaseLabelType<T =any> {
  label: string
  value: T
}


export interface MessageReadBtnType extends BaseLabelType {
  isActive:boolean
  [data:string]:any
}


export interface PaginationConfigType {
    pageSize: number
    setPageSize:React.Dispatch<React.SetStateAction<number>>
    currentPage:number,
    setCurrentPage:React.Dispatch<React.SetStateAction<number>>,
    total:number,
    setTotal:React.Dispatch<React.SetStateAction<number>>,
    tableLoading:boolean,
    setTableLoading:React.Dispatch<React.SetStateAction<boolean>>
}


export type QrcodeStatusType = 'active' | 'expired' | 'loading' | 'scanned'


export interface DropDownPropsType{
  className?:string
  options:BaseLabelType[]
  onChange:BaseFunction
  value?:any
  allowClear?:boolean
}

export interface InvoiceTipsType{
  value:string
  tipValue:string
  className?:string
  [data:string]:any
}

/**
 * 发票抬头
 */
export interface InvoiceTitleInfo{
  invoiceTitleType:InvoiceTitleType
  invoiceType:InvoiceType
  invoiceTitle:any
  taxNumber:string
  baseBank:string
  baseAccount:string
  registerAddress:string
  registerPhone:string
  [data:string]:any
}

export type InvoiceTitleType='person' | 'company' | 'government'

export type InvoiceType='vat' | 'ordinary'


export interface BaseResponseType<T = any> {
  code: number
  message: string
  result: T
  success: boolean
  timestamp: number
}


export interface MessageCenterListBaseResponseResultType<T = any> {
  current: number
  pages:number
  records: T
  size: number
  total: number
}


export interface MessageDataType {
  id: number
  title: string
  createBy?:string
  deleteFlag?:string
  messageType?:string
  receiverId?:string
  receiverPhone?:string
  content: any
  createTime: string
  isRead: boolean
  [data:string]:any
}

export interface PaginationParamsType{
  pageNumber?:number
  pageSize?:number
}

export type MessageListType=BaseResponseType<MessageCenterListBaseResponseResultType<MessageDataType[]>>

export type MessageDetailType=BaseResponseType<MessageDataType>;



export enum PAY_STATUS {
  UNPAID='UNPAID',//待支付
  PAID='PAID',//已支付
}

export enum ORDER_TYPE {
  ORDER='order',//余额支付
  RECHARGE='recharge'//在线充值
}

export enum MESSAGE_ON_TYPE {
  MESSAGE_CHANGE=0,//消息变更
  MESSAGE_REMIND=1,//消息提醒
  ORDER_CHANGE=2,//订单变更
  SCROLL=3,//滚动
}


export interface PayRecordListType{
  sn:any //订单号
  flowPrice:any //流水金额
  payStatus:PAY_STATUS
  groupName:string //产品名称
  createTime:string //创建时间
  paymentTime:string //支付时间
  type:string,//订单类型
  [data:string]:any
}


export interface PaymentOrderParamsType {
  clientType?:'PC' | 'H5'
  orderType?:'ORDER' | 'RECHARGE'
  paymentClient?:'APP' | 'NATIVE'|'JSAPI' |'H5'
  paymentMethod?:"WECHAT" | "ALIPAY" | "WALLET"
  sn:any
  [data:string]:any
}

export interface OrderParamsType extends PaginationParamsType{
  payStatus?:PAY_STATUS
  type?:ORDER_TYPE
  orderSn?:any
  [data:string]:any
}


export enum QuestionAuthFlag{
  REVIEWING=0,
  PASS=1,
  FAIL=2
}


export enum QuestionStatus{
  NOT_START='NOT_START',
  IN_PROGRESS='IN_PROGRESS',
  END='END'
}